import React, { useEffect, useState } from "react";
import "./SectionFour.scss";
import { GreenSubDescription } from "../../../../../Global/GlobalText";
import {
  GreyBorderButton,
  RedBackgroundButton,
  RedBordButton,
} from "../../../../../Global/GlobalButton";
import { IoMdAddCircleOutline } from "react-icons/io";
import {
  InputType,
  SelectBorder,
} from "../../../../../Global/GlobalFormElement";
import { RiDeleteBin6Fill } from "react-icons/ri";
import axios from "axios";
import { toast } from "react-toastify";
import { EXCHNAGE_URL } from "../../../../../../Url/Url";
import { useSelector } from "react-redux";

export const SectionFour = ({ setSelectedButton, selectedFields , filters,  setFilters }) => {

  useEffect(() => {
    console.log("Selected Fields in SectionFour:", selectedFields);
  }, [selectedFields]);

  const [availableFields, setAvailableFields] = useState([]);
  const token = localStorage.getItem("token");
  const eventIdGet = useSelector((state) => state?.users?.id || "");
  const eventId = String(eventIdGet);
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(
          `${EXCHNAGE_URL}/fetchFormFields?eventId=${eventId}`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );
        const data = response.data;

        if (data.status && data.formSchema?.entryFields) {
          setAvailableFields(data.formSchema.entryFields); // Store available fields
        } else {
          throw new Error("Invalid API response format");
        }
      } catch (error) {
        console.error("Error fetching form fields:", error);
        toast.error("Failed to fetch form fields");
      }
    };

    fetchData();
  }, [eventId]); // Runs when eventId changes

  const addFilter = () => {
    setFilters([...filters, { id: Date.now(), selectedField: "", value: "" }]);
  };

  const handleFilterChange = (id, selectedField) => {
    setFilters(filters.map(filter => filter.id === id ? { ...filter, selectedField } : filter));
  };

  const handleInputChange = (id, value) => {
    setFilters(filters.map(filter => filter.id === id ? { ...filter, value } : filter));
  };

  const handleRemoveFilter = (id) => {
    setFilters(filters.filter(filter => filter.id !== id));
  };
  

  return (
    <div>
      <div className="section_four_main">
        <GreenSubDescription>Filter the report</GreenSubDescription>


        {filters.map((filter, index) => (
          <div key={filter.id} className="section_four_row_div">
            <SelectBorder
              className="section_four_label"
              value={filter.selectedField || "Select"}
              onChange={(e) => handleFilterChange(filter.id, e.target.value)}
            >
              <option value="Select">Select</option>
              {availableFields.map((field) => (
                <option key={field.field_name} value={field.field_name}>
                  {field.label}
                </option>
              ))}
            </SelectBorder>

            <InputType
              type="text"
              placeholder="Enter value"
              className="section_four_input"
              value={filter.value || ""}
              onChange={(e) => handleInputChange(filter.id, e.target.value)}
            />

            <RiDeleteBin6Fill onClick={() => handleRemoveFilter(filter.id)} />
          </div>
        ))}


        <div className="section_four_filter_btn">
          <RedBordButton
            className="jury_assignment_pluscontent"
            onClick={addFilter} // Handle button click
          >
            <IoMdAddCircleOutline />
            Add Filter
          </RedBordButton>
        </div>

        <div className="section_four_btn">
          <GreyBorderButton onClick={() => setSelectedButton(3)}>Previous</GreyBorderButton>
          <RedBackgroundButton onClick={() => setSelectedButton(5)}>Next</RedBackgroundButton>
        </div>

      </div>
    </div>
  );
};